import MDEditor from '@uiw/react-md-editor'
import { FC } from 'react'
import { IFaqArticle } from 'screens/Admin/KnowleageBase/faq.types'
import css from './knowleageBaseArticle.module.css'
import cn from 'utils/cn'

interface IProps {
  article?: IFaqArticle
}

const KnowleageBaseArticle: FC<IProps> = (props) => {
  if (!props.article) {
    return (
      <div className={css.wrapper}>
        <h4 className='text--heading-h4'>База знаний</h4>
        <p className='text--body-m'>
          Эта база знаний создана для студентов — здесь собрана вся необходимая информация для 
          выполнения заданий: методички, шаблоны, примеры решений и ответы на часто задаваемые вопросы. 
          Материалы структурированы по темам и регулярно обновляются, чтобы вы могли быстро найти то, что нужно. 
        </p>
        <p className='text--body-m'>
          Выберите статью в меню слева, чтобы начать — откройте нужную категорию или воспользуйтесь поиском. 
          Не нашли нужного материала? Напишите нам, и мы поможем.
        </p>
      </div>
    )
  }

  return (
    <div className={css.wrapper}>
      <h4 className='text--heading-h4'>{props.article.title}</h4>
      <div className='inline-flex-gap'>
        {props.article.searchTags.map((tag) => (
          <div className={cn(css.tag, 'text--body-m')} key={tag.tag.id}>
            {tag.tag.name}
          </div>
        ))}
      </div>
      <MDEditor.Markdown source={props.article?.text} wrapperElement={{ 'data-color-mode': 'light' }} />
    </div>
  )
}

export default KnowleageBaseArticle
